import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Button } from "antd";
import { DeleteOutlined, LinkOutlined } from "@ant-design/icons";
import { confirmMessage } from "../../../../pages/page-builder/grapesjs-service";
import { useAddLesson } from "../../../../stores/stores";
import TextEditor from "../../../text-editor/TextEditor";
import { useDirty } from "../../../../contexts/DirtyProvider";

interface QuestionConnectTextProps {
  index: number;
  content: {
    left: { content?: string };
    right: { content?: string };
  };
  onChange?: (val: {
    id: number;
    content: {
      left: { content: string };
      right: { content: string };
    };
  }) => void;
  onDelete?: (id: number) => void;
}

function QuestionConnect({
  index,
  content,
  onChange = () => { },
  onDelete = () => { },
}: QuestionConnectTextProps) {
const leftValue = content?.left?.content || "";
  const rightValue = content?.right?.content || "";

  const [leftTextValue, setLeftTextValue] = useState<string>("");
  const [rightTextValue, setRightTextValue] = useState<string>("");
  const settingQuestion = useAddLesson((state) => state.settingQuestion);

  const { setDirty } = useDirty();

  const handleChangeLeftText = (value: string) => {
    const changeLeftValue = value;
    setLeftTextValue(changeLeftValue);
    onChange({
      id: index,
      content: {
        left: { content: changeLeftValue },
        right: { content: rightTextValue },
      },
    });
  };

  const handleChangeRightText = (value: string) => {
    const changeRightValue = value;
    setRightTextValue(changeRightValue);
    onChange({
      id: index,
      content: {
        left: { content: leftTextValue },
        right: { content: changeRightValue },
      },
    });
  };

  const handleDeleteSection = (index: number) => {
    confirmMessage(
      "Xóa cặp lựa chọn",
      0,
      "Bạn có chắc muốn xóa cặp lựa chọn này ?",
      () => {
        onDelete(index);
        setDirty(true);
      }
    );
  };

  useEffect(() => {
    if (leftValue) setLeftTextValue(leftValue);
    if (rightValue) setRightTextValue(rightValue);
  }, [leftValue, rightValue]);

  const alphabet1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const alphabet2 = "abcdefghijklmnopqrstuvwxyz";

  function convertToRoman(num: number) {
const romanNumerals = [
      "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X",
      "XI", "XII", "XIII", "XIV", "XV", "XVI", "XVII", "XVIII", "XIX", "XX",
      "XXI", "XXII", "XXIII", "XXIV", "XXV", "XXVI", "XXVII", "XXVIII", "XXIX", "XXX"
    ];
    return romanNumerals[num];
  }

  const markNumberLeftRow =
    settingQuestion.markNumber === 1
      ? alphabet1.charAt(index - 1)
      : settingQuestion.markNumber === 2
        ? alphabet1.charAt(index - 1)
        : settingQuestion.markNumber === 3
          ? index
          : settingQuestion.markNumber === 4
            ? convertToRoman(index)
            : '\u00A0'.repeat(3);
  const markNumberRightRow =
    settingQuestion.markNumber2 === 1
      ? alphabet1.charAt(index - 1)
      : settingQuestion.markNumber2 === 2
        ? alphabet2.charAt(index - 1)
        : settingQuestion.markNumber2 === 3
          ? index
          : settingQuestion.markNumber2 === 4
            ? convertToRoman(index)
            : '\u00A0'.repeat(3);
  return (
    <div className="question-by-type flex-1 mb-2">
      <div className="flex align-center">
        <div className="answer-pair">
          <div className="connect-answer">
            <p className="current-letter">{markNumberLeftRow}</p>
            <TextEditor onChange={handleChangeLeftText} value={leftTextValue} />
          </div>

          <LinkOutlined />

          <div className="connect-answer">
            <p className="current-letter">{markNumberRightRow}</p>
            <TextEditor onChange={handleChangeRightText} value={rightTextValue} />
          </div>
        </div>
        <div className="ml-2 mt-3">
          <Button
            className="delete-btn"
            onClick={() => handleDeleteSection(index)}
            icon={<DeleteOutlined />}
          ></Button>
        </div>
      </div>
    </div>
  );
}

export default QuestionConnect;
